import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../contexts/CartContext';
import { useAuth } from '../../contexts/AuthContext';
import '../styles/BottomTabNav.css';

const IconOrders = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15M9 5C9 5.53043 9.21071 6.03914 9.58579 6.41421C9.96086 6.78929 10.4696 7 11 7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconHome = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <polyline points="9,22 9,12 15,12 15,22" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconCart = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 6h15l-1.5 8.5a2 2 0 0 1-2 1.5H9a2 2 0 0 1-2-1.5L5 2H2" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="9" cy="21" r="1.8" fill={active ? '#ffffff' : '#6b7280'}/>
    <circle cx="17" cy="21" r="1.8" fill={active ? '#ffffff' : '#6b7280'}/>
  </svg>
);

const IconProfile = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM3 21a9 9 0 0 1 18 0" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const IconAbout = ({ active }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2"/>
    <path d="M12 16v-4" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round"/>
    <path d="M12 8h.01" stroke={active ? '#ffffff' : '#6b7280'} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const BottomTabNav = () => {
  const { pathname } = useLocation();
  const { getCartItemCount } = useCart();
  const { isLoggedIn } = useAuth();
  const cartItemCount = getCartItemCount();

  // Define tabs based on login status - place Orders after Cart
  const tabs = [
    { to: '/', icon: IconHome, label: 'Home' },
    { to: '/cart', icon: IconCart, label: 'Cart' },
    ...(isLoggedIn ? [{ to: '/orders', icon: IconOrders, label: 'Orders' }] : []),
    { to: '/profile', icon: IconProfile, label: 'Profile' },
    { to: '/about', icon: IconAbout, label: 'About' },
  ];
  
  return (
    <nav className="bottom-tabs">
      {tabs.map(tab => {
        const active = pathname === tab.to || (tab.to === '/' && pathname === '/menu');
        const Icon = tab.icon;
        return (
          <Link key={tab.to} to={tab.to} className={`tab-item ${active ? 'active' : ''}`}>
            <span className="tab-icon" aria-hidden>
              <Icon active={active} />
            </span>
            {tab.label === 'Cart' && cartItemCount > 0 && (
              <span className="cart-badge">{cartItemCount}</span>
            )}
            <span className="sr-only">{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomTabNav;


